import styled from "styled-components";

import { setFontVariant } from "@similarweb/styles";

const StyledSelectableInput = styled.input`
    ${setFontVariant("input2")};
    width: 100%;
    padding: 0;
    margin: 0;
    border: none;
    outline: none;
    background: transparent;
    color: inherit;
    text-overflow: ellipsis;
    cursor: text;
`;

interface ISelectableTextCellProps {
    value: string;
    dataAutomation?: string;
}

/**
 * Renders the value inside a readonly input that looks exactly like a TextCell.
 * The input keeps the value verbatim, so selecting and copying any part of it returns the raw
 * backend string - unlike a text node, whose whitespace the DOM collapses and breaks search with.
 */
export const SelectableTextCell = ({ value, dataAutomation = "selectable-text-cell" }: ISelectableTextCellProps) => (
    <StyledSelectableInput
        data-automation={dataAutomation}
        readOnly
        tabIndex={-1}
        value={value}
    />
);
